module.exports = __webpack_public_path__ + "static/media/wl1024.97a9e3a3.png";